import { Show } from "solid-js";

type CustomAmountPillProps = {
  isSelected: boolean;
  onClick: () => void;
  class?: string;
};

function CheckIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CustomAmountPill(props: CustomAmountPillProps) {
  return (
    <button
      class={`relative flex h-9 cursor-pointer items-center justify-center gap-2.5 rounded-lg border  py-2.5 transition-colors ${props.class || ""}`}
      classList={{
        "border-stroke-solid bg-background-normal-primary": props.isSelected,
        "border-stroke-2 bg-background-normal-primary hover:border-stroke-solid":
          !props.isSelected,
        "border-[1.5px]": props.isSelected,
      }}
      onClick={props.onClick}
    >
      <div
        class="flex flex-1 flex-col justify-center text-center"
        classList={{
          "text-para-3-semi-bold text-text-normal-primary": props.isSelected,
          "text-para-3-medium text-text-normal-secondary": !props.isSelected,
        }}
      >
        <p class="whitespace-nowrap leading-5">Custom</p>
      </div>
      <Show when={props.isSelected}>
        <div class="absolute right-1 top-[3px] h-3 w-3 text-text-normal-primary">
          <CheckIcon />
        </div>
      </Show>
    </button>
  );
}
